import script from "./TeamShowcase.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamShowcase.vue?vue&type=script&setup=true&lang=js"

import "./TeamShowcase.vue?vue&type=style&index=0&id=aa8d5c42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa8d5c42"]])

export default __exports__